interface Props {
	className: string;
	date: Date | string;
}

export default function StackedDate(props: Props) {
	const date = typeof props.date === "string" ? new Date(props.date) : props.date;
	const shortMonthName = new Intl.DateTimeFormat("en-US", { month: "short" }).format;

	return (
		<div className={`${props.className} text-black font-label w-10 text-center uppercase`}>
			<div className="text-sm">{shortMonthName(date)}</div>
			<div className="text-2xl ">{date.getDate()}</div>
			<div className="text-sm ">{date.getFullYear()}</div>
		</div>
	);
}
